export default __webpack_public_path__ + "static/media/Img0010.db28a199.png";